import { tracer } from '../../tracers';
import { WS_HUB_SERIAL, WS_METHOD, WS_PARAMS } from '../../constants/attributeNames';
import { EVENTS, HUB_COMMAND, SEVERITY_TEXT } from '../../constants';
import { withSafelyExecute } from '../../utils/withSafelyExecute';
import otlWsSuccess from './otlWsSuccess';
import otlWsReject from './otlWsReject';
import { getEnvKey } from 'constants/envs';
import { log } from '../../logging';
import { getIdsFromSpan } from '../../utils';
import { getDynamicWSLogAttributes } from '../../utils/getDynamicWSLogAttributes';
import { traceContextService } from '../../services/TraceContextService';

/**
 * Initializes OpenTelemetry tracing for a WebSocket operation.
 *
 * @param {Object} payload - The payload data for the WebSocket operation.
 * @param {string|number} payload.serial - The serial number of the hub.
 * @param {string} payload.method - json-rpc method name.
 * @param {Object} payload.params - json-rpc params.
 * @returns {Object} An object containing the span, onSuccess, and onError handlers.
 */
function initialWsOtl(payload) {
    const { serial, method, params } = payload;
    const span = tracer.startSpan(
        `WS send ${method}`,
        {
            [WS_HUB_SERIAL]: serial,
            [WS_METHOD]: method,
            [WS_PARAMS]: JSON.stringify(params),
            environment: getEnvKey(),
        },
        traceContextService.getActiveParentContext(),
    );

    span.addEvent(EVENTS.WS_SEND_REQUEST_STARTED);
    log(`Start WS ${method} call`, SEVERITY_TEXT.INFO, {
        hub_serial: serial,
        api: method,
        type: HUB_COMMAND,
        ...getIdsFromSpan(span),
        ...getDynamicWSLogAttributes({ serial, params }),
    });

    const onSuccess = (response) => {
        otlWsSuccess(span, response, payload);

        return Promise.resolve(response);
    };

    const onError = (error) => {
        otlWsReject(span, error, payload);

        return Promise.reject(error);
    };

    return {
        span,
        onSuccess,
        onError,
    };
}

export default withSafelyExecute(initialWsOtl);
